/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from 'ethers'
import { Provider } from '@ethersproject/providers'
import type {
  IPredyTradeCallback,
  IPredyTradeCallbackInterface
} from '../IPredyTradeCallback'

const _abi = [
  {
    inputs: [
      {
        components: [
          {
            components: [
              {
                internalType: 'int256',
                name: 'perpEntryUpdate',
                type: 'int256'
              },
              {
                internalType: 'int256',
                name: 'sqrtEntryUpdate',
                type: 'int256'
              },
              {
                internalType: 'int256',
                name: 'sqrtRebalanceEntryUpdateUnderlying',
                type: 'int256'
              },
              {
                internalType: 'int256',
                name: 'sqrtRebalanceEntryUpdateStable',
                type: 'int256'
              },
              {
                internalType: 'int256',
                name: 'perpPayoff',
                type: 'int256'
              },
              {
                internalType: 'int256',
                name: 'sqrtPayoff',
                type: 'int256'
              }
            ],
            internalType: 'struct Perp.Payoff',
            name: 'payoff',
            type: 'tuple'
          },
          {
            internalType: 'int256',
            name: 'fee',
            type: 'int256'
          },
          {
            internalType: 'int256',
            name: 'minDeposit',
            type: 'int256'
          }
        ],
        internalType: 'struct DataType.TradeResult',
        name: '_tradeResult',
        type: 'tuple'
      },
      {
        internalType: 'bytes',
        name: 'data',
        type: 'bytes'
      }
    ],
    name: 'predyTradeCallback',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  }
]

export class IPredyTradeCallback__factory {
  static readonly abi = _abi
  static createInterface(): IPredyTradeCallbackInterface {
    return new utils.Interface(_abi) as IPredyTradeCallbackInterface
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): IPredyTradeCallback {
    return new Contract(address, _abi, signerOrProvider) as IPredyTradeCallback
  }
}
